import { render } from "./MobileApp.vue?vue&type=template&id=4cf473ec&scoped=true"
import script from "./MobileApp.vue?vue&type=script&lang=js"
export * from "./MobileApp.vue?vue&type=script&lang=js"

import "./MobileApp.vue?vue&type=style&index=0&id=4cf473ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf473ec"]])

export default __exports__